import React from 'react'
import { Link } from 'react-router-dom'
import { PageHero, Prose } from './_shared'
import { OWNER_EMAIL } from '../../components/Footer'

const UPDATED = 'June 2026'

export default function Terms() {
  return (
    <>
      <PageHero kicker="Legal" title="Terms of Use" lede={`The basics of using serenDPT. Last updated ${UPDATED}.`} />
      <Prose>
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          serenDPT is a personal, self-hosted tool. These terms are provided in good faith and are
          not legal advice. Review and adapt them for your own use.
        </div>

        <h2>1. No investment advice</h2>
        <p>
          serenDPT provides portfolio analytics, research and informational signals only. Nothing
          it shows — scores, rankings, rebalancing suggestions or alerts — is a recommendation,
          solicitation, or advice to buy or sell any security. All investment decisions, and their
          consequences, are entirely your own.
        </p>

        <h2>2. Markets carry risk</h2>
        <p>
          Investing involves risk, including the possible loss of principal. Past performance does
          not guarantee future results. Live data is only as accurate as the most recent verified
          source and may be delayed or incomplete.
        </p>

        <h2>3. Broker connections &amp; orders</h2>
        <p>
          Where order placement is enabled, orders are executed through your own connected broker
          account and are subject to that broker’s terms, limits and approvals. You are responsible
          for keeping your credentials secure and for every action taken in your accounts.
        </p>

        <h2>4. Personal use &amp; “as is”</h2>
        <p>
          The platform is provided <strong>as is</strong>, without warranties of any kind, express
          or implied. To the maximum extent permitted by law, the author is not liable for any loss
          or damage arising from its use, including trading losses, data loss, or service
          interruption.
        </p>

        <h2>5. Third-party services</h2>
        <p>
          Features that rely on external services (brokers, market-data providers, and others)
          depend on those services’ availability and are governed by their respective terms.
        </p>

        <h2>6. Changes</h2>
        <p>
          These terms may be updated as the platform evolves. Continued use after a change
          constitutes acceptance of the revised terms.
        </p>

        <h2>Contact</h2>
        <p>
          Questions? <Link to="/contact">Reach out</Link> or email{' '}
          <a href={`mailto:${OWNER_EMAIL}`}>{OWNER_EMAIL}</a>.
        </p>
      </Prose>
    </>
  )
}
